import type { CollectionQueryState, CollectionQueryAdapter } from '@common/adapters/collection-query';
import { type Testimonial } from '@common/types/testimonial.type';

import { createReducer, on } from '@ngrx/store';

import { createCollectionQueryAdapter } from '@common/adapters/collection-query';
import TestimonialsActions from './testimonials.actions';

export const TESTIMONIALS_COLLECTION_FEATURE_KEY = 'testimonials';

export type TestimonialsCollectionState = CollectionQueryState<Testimonial[]>;

export const testimonialsAdapter: CollectionQueryAdapter<Testimonial[]> = createCollectionQueryAdapter<Testimonial[]>();

export const testimonialsCollectionReducer = createReducer<TestimonialsCollectionState>(
    testimonialsAdapter.getInitialState(),
    on(TestimonialsActions.loadCollectionRequest, (state: TestimonialsCollectionState, { courseId }) =>
        testimonialsAdapter.loadCollectionQueryRequest(state, courseId)
    ),
    on(TestimonialsActions.loadCollectionSuccess, (state: TestimonialsCollectionState, { courseId, testimonials }) =>
        testimonialsAdapter.loadCollectionQuerySuccess(testimonials, courseId, state)
    ),
    on(TestimonialsActions.loadCollectionFailure, (state: TestimonialsCollectionState, { courseId, error }) =>
        testimonialsAdapter.loadCollectionQueryFailure(error, courseId, state)
    )
);
